import { useState } from 'react';

const UseModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsShowing(!isShowing);
  }

  return {
    isShowing,
    toggle,
  }
};

export default UseModal;